module.exports = __webpack_public_path__ + "img/zsfw.9f8b4bcf.png";